// Format date to DD-MM-YYYY
const formatDate = (dateString: string | undefined | null): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export default formatDate;

const parseDate = (dateString: string): Date | null => {
  if (!dateString) return null;

  if (/^\d{2}\/\d{2}\/\d{2}$/.test(dateString)) {
    const [yearStr, monthStr, dayStr] = dateString.split("/");
    const year = parseInt(yearStr, 10) + 2000;
    const month = parseInt(monthStr, 10) - 1;
    const day = parseInt(dayStr, 10);
    const date = new Date(year, month, day);

    if (
      !isNaN(date.getTime()) &&
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day
    ) {
      return date;
    }
  }

  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    const [dayStr, monthStr, yearStr] = dateString.split("-");
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10) - 1;
    const day = parseInt(dayStr, 10);
    const date = new Date(year, month, day);

    if (
      !isNaN(date.getTime()) &&
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day
    ) {
      return date;
    }
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return date;
    }
  }

  console.error(`Unknown or invalid date format: ${dateString}`);
  return null;
};

export const formatDateToLongString = (
  dateString: string | undefined | null
): string => {
  if (!dateString) return "";

  const date = parseDate(dateString);
  if (!date) {
    return dateString;
  }

  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  return date.toLocaleDateString("en-GB", options);
};

export const formatDateForDisplay = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
};

export const formatTime = (timeString?: string) => {
  if (!timeString) return "";
  return `${timeString.substring(0, 5)} HRS (CAT)`;
};

export const formatToDateString = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-US", { month: "long" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

export const formatLifespan = (dob?: string, dod?: string) => {
  if (!dob || !dod) return "";
  return `${formatToDateString(dob)} - ${formatToDateString(dod)}`;
};
